export const global = {
    namespaced: true,
    state: {
        conexionApi: false,
        conectandoApi: true,
        versionBack: '',
        versionBFF: '',
        versionFront: JSON.stringify(require("../../../../package.json").version).replace(/"/g, ""), //se obtiene del fichero package.json ubicado en la raíz
        urlApi: 'wwww',
        rootPath: '',
        drawer: true,
        mini: false,
        entorno: '',
        soporteCorreo: '',
        miga: [],
        busquedaGlobal: '',
        documentosFileLimit: { n: 10, u: "MB" },
        mensajePrincipalLayout: '',
        tipoPrincipalLayout: '',
        mostrarMensajePrincipalLayout: false,
        errorComunicacionApi: false,
        tiempoFichaje: 5,
    },
    mutations: {
        SET_VERSION(state, newVersion) {
            state.versionBack = newVersion.versionBack;
            state.versionBFF = newVersion.versionBFF;
        }, 
        SET_MIGA(state, newMiga) {
            state.miga = newMiga;
        },
        SET_CONEXION(state, newConexionApi) {
            state.conexionApi = newConexionApi;
            state.conectandoApi = false;
        },
        SET_CONECTANDO(state, newConectandoApi) {
            state.conectandoApi = newConectandoApi;
        },
        SET_CONFIG(state, config) {
            state.urlApi = config.ROOT_API;
            state.rootPath = config.PATH_URL;
            state.entorno = config.ENTORNO;
            state.soporteCorreo = config.SOPORTE_CORREO;
            state.tiempoFichaje = parseInt(config.TIEMPO_FICHAJE);
            //baseService.defaults.baseURL = config.ROOT_API
            window.urlApi = state.urlApi;
        },
        SET_DRAWER(state, visible) {
            state.drawer = visible;
        },
        SET_MINI(state, options) {
            if (options.lgAndUp){
                state.mini = options.mini;
                //state.drawer = true;
            }else{
                state.mini = false;
                state.drawer = true;
            }
        },
        SET_BusquedaGlobal(state, newbusquedaGlobal){
            state.busquedaGlobal = newbusquedaGlobal;
        },
        SET_AlertMensaje(state, alert){
            state.tipoPrincipalLayout = alert.tipo;
            state.mensajePrincipalLayout = alert.mensaje;
            state.mostrarMensajePrincipalLayout = true;
        },
        SET_CerrarAlertMensaje(state){
            state.mensajePrincipalLayout = '';
            state.mostrarMensajePrincipalLayout = false;
        }
    },
    actions: {
        async  GetConfig({ commit, dispatch }) {
            const config = await globalService.getConfig();
            commit("SET_CONFIG", config);
            dispatch("GetVerions");
        }
    },
    getters: {
        getMigas(state) {
            return state.miga;
        }
    }
}